export default "__VITE_ASSET__6e8c5dd0__"